/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning asset type values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_ASSET_TYPES } from '@shared/constants';
 * 
 * if (asset.type === LEARNING_ASSET_TYPES.IMAGE) {
 *   // Handle image asset
 * }
 * ```
 */
export const LEARNING_ASSET_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  LINK: 'link',
  FILE: 'file'
} as const; 